const data = [
	{
		id: 0,
		text: 'home',
		url: '/',
	},
	{
		id: 1,
		text: 'articles',
		url: '/articles/',
	},
	{
		id: 2,
		text: 'categories',
		url: '/articles/categories/',
	},
	{
		id: 3,
		text: 'About',
		url: '/about',
	},
]

export default data
